import { DialogContent } from "@material-ui/core"

import { ReactNode } from "react"
import Dialog from "@material-ui/core/Dialog"
import { chartStyles } from "../../../../styles"

export type ExpandLineChartDialogProps = {
  open: boolean
  onClose: () => void
  children: ReactNode
  width: number
}

export const BaseChartDialog = ({
  open,
  onClose,
  children,
  width,
}: ExpandLineChartDialogProps) => {
  return (
    <Dialog
      maxWidth={false}
      PaperProps={{
        style: {
          width: width,
          height: "100%",
          zIndex: 1,
          backgroundColor: "var(--extra-dark-grey-2)",
          boxShadow: "none",
        },
      }}
      className={chartStyles.shadow}
      open={open}
      onClose={onClose}
    >
      <DialogContent
        style={{
          zIndex: -1,
          display: "flex",
          flexDirection: "column",
          padding: "35px",

          overflow: "hidden",
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  )
}
